import { css } from 'linaria'
import theme, { COLORS } from '../../styles/theme'
import fontSizes from '../../styles/fontSizes'

const classes = {
  container: css`
    box-sizing: border-box;
    color: ${COLORS.white};
    padding: ${theme.spacing(1.5)}px;
    width: 100%;
    @media (max-width: ${theme.breakpoints.values.sm}px) {
      min-height: 90px;
    }

    &.sticky {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1101;
    }
  `,
  wrapper: css`
      position: relative;
      align-items: center;
      justify-content: center;
    #nav-container {
    grid-gap: ${theme.spacing(1)}px;
    display: flex;
    flex-direction: column;
    }
    ${theme.breakpoints.up('md')} {
    grid-gap: ${theme.spacing(3)}px;
    display: flex;
    #nav-container {
      flex-direction: row-reverse;
      position:absolute;
      right: ${theme.spacing(5)}px;
    }

    }
    ${theme.breakpoints.down('md')} {
    grid-gap: ${theme.spacing(2)}px;
    display: grid;
    grid-template-areas: 
      "text text text text nav"
      ". . countdown . .";
       grid-template-columns: repeat(5, 1fr);
    grid-gap: ${theme.spacing(2)}px;

    #text-container {
      grid-area: text;
      justify-self: start;
    }

    .countdown {
      grid-area: countdown;
      justify-self: center;
      align-self: center;
    }

    #nav-container {
      grid-area: nav;
      align-self: start;
      margin-top:4px;
      ${theme.breakpoints.up('sm')} {
      flex-direction: row-reverse;
      justify-content:end;
      height: unset;
      }
    }
    }
    
    ${theme.breakpoints.up('sm')} {
    grid-template-areas: 
      ". text text text nav"
      ". . countdown . nav";
    }
   

    ${theme.breakpoints.down('sm')} {
      grid-template-areas:
        "text text nav"
        "countdown countdown countdown";
      grid-template-columns: 1fr;

      #text-container {
        justify-self: start;
        width: 100%;
      }

      .countdown {
        justify-self: center;
      }

      #nav-container {
        flex-direction: column;
        justify-self: end;
        width: 100%;
      }
    }
  `,
  countdownNumber: css`
    &.MuiTypography-body1 {
      line-height: 1.2;
    }
  `,
  countdownLabel: css`
    &.MuiTypography-root {
      font-size: ${fontSizes.smallText};
    }
  `,
}

export default classes
